/**
 * 블소 - 문파
 */
import { useMemo, Fragment } from 'react';
import { CUR_NETWORK, NSHOP_DOMAIN, SERVICE_ALIAS } from '@constants/index';
import { numberWithCommas } from '@utils/index';
import type { IGoods, ISetGoods, l10nType } from '@type/index';

// 2차 오픈 - 통합 N샵
export const setGoodsItem = (item: IGoods, l10n: l10nType, serviceAlias: string): ISetGoods | null => {
  return item && typeof item === 'object'
    ? {
        ...item,
        url: `${NSHOP_DOMAIN[CUR_NETWORK]}/${item?.shopCode}/goods/${item?.id}`,
        serverName:
          serviceAlias === SERVICE_ALIAS.AION ? (item?.shopCode === 'aionc' ? l10n?.filter?.aionClassicServer : l10n?.filter?.aionLiveServer) : '',
        currencyType: item?.currencyGroupId === 13 ? 'point' : 'cash',
      }
    : null;
};

const NshopArticle = ({ item, l10n, option }: { item: IGoods; l10n: l10nType; option: IOption;}) => {
  const { serviceAlias } = option;
  const data = useMemo(() => setGoodsItem(item as IGoods, l10n, serviceAlias), [item, l10n]);

  if (!data) {
    return <Fragment />;
  }

  const { url, thumbnailUri, serverName, goodsName, currencyType, salePrice, rewardValue } = data;
  return (
    <div className="search-item-content">
      <div className="search-item-thumbnail">
        <a href={url}>
          <div className="search-item-thumbnail-inner">
            {thumbnailUri ? <img src={thumbnailUri} alt="아이템" /> : <Fragment />}
            {serverName ? <span className="server-name">{serverName}</span> : <Fragment />}
          </div>
        </a>
      </div>
      <div className="search-item-article">
        <div className="search-item-title">
          <a href={url} dangerouslySetInnerHTML={{ __html: goodsName }}></a>
        </div>
        <div className="search-item-info">
          <span className={`${currencyType}`}>{numberWithCommas(salePrice)}</span>
          <span className="point">
            {rewardValue}({l10n?.template?.accumulate})
          </span>
        </div>
      </div>
    </div>
  );
};

export default NshopArticle;
